import type { TextFeatureVariable } from '@mc/feature-variables'

const DISCOUNT_STYLE = 'mc-text-color--primary'

export const splitBannerTitle = (title?: TextFeatureVariable) => {
  if (!Array.isArray(title)) return null

  const discountIndex = title.findIndex(({ style = '' }) =>
    style.split(' ').includes(DISCOUNT_STYLE),
  )
  if (discountIndex === -1) return null

  const promoName = title.slice(discountIndex + 1)
  if (!promoName.some(({ copy }) => copy.trim())) return null

  return {
    lead: title.slice(0, discountIndex + 1),
    promoName,
  }
}
